import { render, staticRenderFns } from "./LastWinner.vue?vue&type=template&id=4398111f&"
import script from "./LastWinner.vue?vue&type=script&lang=js&"
export * from "./LastWinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports